import { h, FunctionComponent } from 'preact';
import { ReachTabs } from 'components/Reach';
import { TabsContainer } from './Tabs.styles';

interface TabsProps {
  activeTabIndex?: number;
  onSelectionChange?: (key: string | number) => void;
  className?: string;
  children?: any;
}

const Tabs: FunctionComponent<TabsProps> = ({
  activeTabIndex,
  onSelectionChange,
  children,
}) => {
  return (
    <TabsContainer>
      <ReachTabs
        index={activeTabIndex}
        onChange={onSelectionChange ?? undefined}
      >
        {children}
      </ReachTabs>
    </TabsContainer>
  );
};

export default Tabs;
